/**
 * @param {Object} errors - A VeeValidate ErrorBag
 * @param {string} key - name attribute of an element that has a VeeValidate directive
 * @return {undefined|null|String} If the key exists in the VeeValidate FieldBag and that
 * field is invalid, then it returns the first validation error message associated
 * with that field. See:
 * https://vee-validate.logaretm.com/v2/api/errorbag.html#api
 */
// eslint-disable-next-line import/prefer-default-export
export const getMessageForError = (errors = {
  first: () => {},
}, key) => errors.first && errors.first(key);
